import { de } from '../../i18n'
import type { DataSourceRunStatus } from './types'

export type StatusTone = 'neutral' | 'success' | 'danger'

/** §6's Datenquellen section: what tone and label a data source's last run gets. */
export function dataSourceStatusLabel(status: DataSourceRunStatus): string {
  if (status === 'running') return de.users.detail.status.running
  if (status === 'success') return de.users.detail.status.success
  if (status === 'error') return de.users.detail.status.error
  return de.users.detail.never
}

export function dataSourceStatusTone(status: DataSourceRunStatus): StatusTone {
  if (status === 'error') return 'danger'
  if (status === 'success') return 'success'
  return 'neutral'
}
